import {useAppSelector} from 'hooks'

import {useAppDispatch} from 'store'

import {ILicenseItem} from 'api/productApi'
import {
  handleGetListLicenseLogs,
  handleGetListLicenseWithItem,
  selectedLicenseData,
  selectError,
  selectListActive,
  selectListDiscontinue,
  selectListLicenseLogs,
  selectListLicenseWithItem,
  selectLoading,
  setSelectLicense,
} from './productInstitutionOperationHistorySlice'

export default function useProductInstitutionOperationHistory() {
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoading)
  const error = useAppSelector(selectError)
  const selectedId = useAppSelector(selectedLicenseData)
  const listLicenseWithItem = useAppSelector(selectListLicenseWithItem)
  const listLicenseLogs = useAppSelector(selectListLicenseLogs)
  const listActive = useAppSelector(selectListActive)
  const listDiscontinue = useAppSelector(selectListDiscontinue)

  const onSearchLicenseLogs = (payload: ILicenseItem) => {
    try {
      dispatch(handleGetListLicenseLogs(payload.licenseId))
      dispatch(setSelectLicense(payload))
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
  }
  const onSearchLicenseWithId = (licenseId: string) => {
    try {
      dispatch(handleGetListLicenseLogs(licenseId))
    } catch (e) {
      console.error('Update URLSearchParams failed', e)
    }
  }
  const fetchLicenseWithItem = (payload: URLSearchParams) => {
    try {
      dispatch(handleGetListLicenseWithItem(payload))
    } catch (e) {
      console.error('fetchLicense failed', e)
    }
  }

  return {
    loading,
    error,
    fetchLicenseWithItem,
    onSearchLicenseLogs,
    onSearchLicenseWithId,
    selectedId,
    listLicenseWithItem,
    listLicenseLogs,
    listActive,
    listDiscontinue,
  }
}
